export { LoadingSkeleton, type LoadingSkeletonProps } from "./LoadingSkeleton";
